import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiCheckCircle, FiClock } from 'react-icons/fi';
import IconWrapper from '../print-steps/IconWrapper';
import { clearKYCStore } from '../../store/kycStore';

const SuccessStep: React.FC = () => {
  const navigate = useNavigate();
  
  // Clear the KYC store data when the success step is shown
  useEffect(() => {
    // Wait a bit to ensure any pending state updates are complete
    const timer = setTimeout(() => {
      console.log('Clearing KYC store data');
      clearKYCStore();
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);
  
  const handleGoHome = () => {
    navigate('/');
  };
  
  return (
    <div className="max-w-lg mx-auto text-center">
      <div className="flex justify-center mb-6">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
          <IconWrapper icon={FiCheckCircle} className="h-8 w-8 text-green-600" />
        </div>
      </div>
      
      <h2 className="text-2xl font-bold text-gray-900 mb-4">
        KYC Submitted Successfully!
      </h2>
      
      <p className="text-gray-600 mb-6">
        Thank you for completing your KYC verification process. Our team will review your submission and verify your documents.
      </p>
      
      <div className="bg-blue-50 rounded-lg p-4 mb-8">
        <div className="flex items-center">
          <IconWrapper icon={FiClock} className="h-5 w-5 text-blue-500 mr-2 flex-shrink-0" />
          <p className="text-sm text-blue-700">
            This process typically takes 1-2 business days. You'll be notified via email once your verification is complete.
          </p>
        </div>
      </div>
      
      <div className="mt-8">
        <button
          onClick={handleGoHome}
          className="inline-flex items-center px-6 py-3 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
        >
          Return to Homepage
        </button>
      </div>
    </div>
  );
};

export default SuccessStep;
